import components from '../../common/_components';
import './page-deals-add.scss';
import {_on} from "../../../../../assets/common/_events";

const blockName = 'page-deals-add';
